const errorParseNetwork = (error) => {

	if (error?.status === 500) {
		return "Ошибка сервера"
	}

	let errorMessages = [];

	if (Array.isArray(error.data)) {
		error.data.map((error) => {
			errorMessages.push(error?.message || error);
		})
	}

	return errorMessages.join("<br/>") || "Ошибка сервера"
}

export default errorParseNetwork
